$(document).on('turbolinks:load', function(){
  $(document).on('shown.bs.modal', '#publish-story', function() {
    $("select.image-picker").imagepicker({
      changed: function(select, newValues, oldValues, event){
        $('#blog_category_ids').val(newValues);
      }
    });
  });
});